import { TasksTable } from '../TasksTable'

const FinalizedTasks = () => {
  return <TasksTable type="finalised" />
}

export default FinalizedTasks
